import { Component, ContentChild, input, OnInit, output } from '@angular/core';

import { XiModalContentDirective } from 'app/directives/xi-modal-content.directive';
import {
  EnableClassTelemetry,
  EnableComponentTelemetry,
  injectComponentTelemetryService,
} from 'app/services/otel.service';

@EnableClassTelemetry()
@Component({
  selector: 'app-lex-xi-modal',
  templateUrl: './lex-xi-modal.component.html',
  styleUrls: ['./lex-xi-modal.component.css'],
  standalone: false,
})
export class LexXiModalComponent implements OnInit {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();
  readonly isVisible = input<boolean>();
  readonly allowScroll = input<boolean>(true);
  readonly canBackdropClose = input<boolean>(true);
  readonly allowPropagation = input<boolean>(false);
  readonly maxWidth = input<string>('720px');
  readonly isFullPage = input<boolean>(true);

  readonly close = output<any>();

  @ContentChild(XiModalContentDirective) content: XiModalContentDirective;

  targetElement: string;

  ngOnInit() {
    if (this.isFullPage()) {
      this.targetElement = 'body';
    }
  }

  onClose() {
    this.close.emit(null);
  }
}
